export const PENDING_CODE = 'PENDING_CODE';
export const WAITING = 'WAITING';
export const ACTIVE = 'ACTIVE';
